import React, {ReactElement, useState} from "react";
import {Tooltip} from "flowbite-react";


type CopyToClipboardProps = {
  text: string;
  CopyButton: (props: {handleCopy: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => void}) => ReactElement;
}

export function CopyToClipboardButton({text, CopyButton}: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, 3333);
        })
        .catch(err => console.error('Failed to copy: ', err));
  };

  return (
      <div
          className={"flex flex-row"}
      >
        {copied ? <Tooltip
            content={"Copied!"}
            placement="top"
        >
          <CopyButton handleCopy={handleCopy} />
        </Tooltip> : <CopyButton handleCopy={handleCopy} />}
      </div>
  );
}
